export default __webpack_public_path__ + "static/SR USA - Fiche de Données Sécurité - Caramel colorant (Poudre)-ea2340774d4c932366570e0e7341b942.pdf";